// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-library-error-svg[data-v-6535561e] {\n  max-width: 40%;\n  height: auto;\n  width: auto;\n}", ""]);
// Exports
module.exports = exports;
